'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './ProjectFeatured.module.scss'
import { useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import LazyImage from '@/components/common/LazyImage'
import { Category, Typology } from '@/types/singles/category'
import { Image } from '@/types/common/ImageData'

interface ProjectFeaturedProps {
    data: DataProps;
    full?: boolean;
}

interface ImageProp {
    image: Image;
    imageMobile: Image | null;
}

interface DataProps {
    title: string;
    slug: string;
    featuredImage: ImageProp | null;
    featuredImageHover: ImageProp | null;
    location: string | null;
    typologies: Array<Typology>;
}

export default function ProjectFeaturedComplexComponent({
data, full
}: ProjectFeaturedProps) {

    const [hover, setHover] = useState(false);

    const [isMobile, setIsMobile] = useState(false);
            
    // Detectar si es mobile o desktop
    useEffect(() => {
        const checkScreenSize = () => setIsMobile(window.innerWidth < 768);
        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);
        
        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    return (
        <Link href={`/projects/${data.slug}`}>
        <div 
            className={`${s.projectFeatured} ${data.featuredImage && s.hasImage}`}
            
        >

            <div className={s.content}>
                <h2>{data.title}</h2>
                {data.location && <h3>{data.location}</h3>}
            </div>
            <div className={`${s.imageContainer} ${full && s.imageFull}`}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                {data.featuredImage &&
                <div className={`${s.image} ${hover ? s.hidden : ''}`}>
                    {isMobile ? data.featuredImage.imageMobile ? <LazyImage
                        src={data.featuredImage.imageMobile.imageUrl}
                        width={data.featuredImage.imageMobile.metadata.dimensions.width}
                        height={data.featuredImage.imageMobile.metadata.dimensions.height}
                        blurDataURL={data.featuredImage.imageMobile.ref}
                        fill={true}
                        alt={data.featuredImage.imageMobile.attribution || ""}
                        caption={data.featuredImage.imageMobile.caption || null}
                        filename={data.featuredImage.imageMobile.filename || ""}
                    /> : <LazyImage
                        src={data.featuredImage.image.imageUrl}
                        width={data.featuredImage.image.metadata.dimensions.width}
                        height={data.featuredImage.image.metadata.dimensions.height}
                        blurDataURL={data.featuredImage.image.ref}
                        fill={true}
                        alt={data.featuredImage.image.attribution || ""}
                        caption={data.featuredImage.image.caption || null}
                        filename={data.featuredImage.image.filename || ""}
                    /> : <LazyImage
                        src={data.featuredImage.image.imageUrl}
                        width={data.featuredImage.image.metadata.dimensions.width}
                        height={data.featuredImage.image.metadata.dimensions.height}
                        blurDataURL={data.featuredImage.image.ref}
                        fill={true}
                        alt={data.featuredImage.image.attribution || ""}
                        caption={data.featuredImage.image.caption || null}
                        filename={data.featuredImage.image.filename || ""}
                    />}
                    
                </div>}
                {data.featuredImageHover &&
                <div className={`${s.image} ${hover ? '' : s.hidden}`}>
                    {isMobile ? data.featuredImageHover.imageMobile ? <LazyImage
                        src={data.featuredImageHover.imageMobile.imageUrl}
                        width={data.featuredImageHover.imageMobile.metadata.dimensions.width}
                        height={data.featuredImageHover.imageMobile.metadata.dimensions.height}
                        blurDataURL={data.featuredImageHover.imageMobile.ref}
                        fill={true}
                        alt={data.featuredImageHover.imageMobile.attribution || ""}
                        caption={data.featuredImageHover.imageMobile.caption || null}
                        filename={data.featuredImageHover.imageMobile.filename || ""}
                    /> : <LazyImage
                        src={data.featuredImageHover.image.imageUrl}
                        width={data.featuredImageHover.image.metadata.dimensions.width}
                        height={data.featuredImageHover.image.metadata.dimensions.height}
                        blurDataURL={data.featuredImageHover.image.ref}
                        fill={true}
                        alt={data.featuredImageHover.image.attribution || ""}
                        caption={data.featuredImageHover.image.caption || null}
                        filename={data.featuredImageHover.image.filename || ""}
                    /> : <LazyImage
                        src={data.featuredImageHover.image.imageUrl}
                        width={data.featuredImageHover.image.metadata.dimensions.width}
                        height={data.featuredImageHover.image.metadata.dimensions.height}
                        blurDataURL={data.featuredImageHover.image.ref}
                        fill={true}
                        alt={data.featuredImageHover.image.attribution || ""}
                        caption={data.featuredImageHover.image.caption || null}
                        filename={data.featuredImageHover.image.filename || ""}
                    />}
                    
                </div>}
            </div>
        </div>
        </Link>
    )
}
